import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'distance',
    pure: false
})
export class DistancePipe implements PipeTransform {

  transform(value: any): any {
    if (Math.floor(value) <= 0) {
      return `${Math.floor(value * 1000)} m`;
    } else {
      return `${(Math.floor(value * 1000) / 1000).toFixed(2)} km`;
    }
  }
}
